
export default {
  name: 'BlogSearchBar',
  data() {
    return {
      keyword: ''
    }
  },
  methods: {
    search() {
      if (this.keyword && this.keyword.length >= 3) {
        this.$router.push(this.localePath({ 
          path: `/blog/search`, 
          query: { q: this.keyword }
        }));
      }
    }
  }
}
